import * as SliderPrimitive from "@radix-ui/react-slider"

import styles from "./Slider.module.css"

type Props = Readonly<
  Pick<
    SliderPrimitive.SliderProps,
    "min" | "max" | "step" | "value" | "onValueChange"
  >
>

export const Slider = ({ value, ...props }: Props) => (
  <SliderPrimitive.Root {...props} className={styles.root} value={value}>
    <SliderPrimitive.Track className={styles.track}>
      <SliderPrimitive.Range className={styles.range} />
    </SliderPrimitive.Track>
    {value?.map((_, i) => (
      <SliderPrimitive.Thumb className={styles.thumb} key={i} />
    ))}
  </SliderPrimitive.Root>
)
